import React from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PageHeader = ({ title, backTo }) => {
  const navigate = useNavigate();

  return (
    <div className="mb-5 w-full pt-1">
      <div className="flex items-center gap-3">
        {/* Back Button */}
        <button
          onClick={() => (backTo ? navigate(backTo) : navigate(-1))}
          className="-ml-1 flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-2xl bg-white text-primary shadow-[0_5px_16px_rgba(20,35,58,0.08)] transition active:scale-95"
          aria-label="Go Back"
        >
          <ArrowLeft className="h-[21px] w-[21px]" strokeWidth={2.4} />
        </button>

        {/* Title */}
        <h1 className="truncate text-[22px] font-extrabold tracking-[-0.02em] text-ink">
          {title}
        </h1>
      </div>
    </div>
  );
};

export default PageHeader;
